export enum MarketingStatus {
	pending = 0,
	sending = 1,
	done = 2
}

export enum MarketingUserStatus {
	noMessage = -1,
	pending = 0,
	sent = 1,
	received = 2,
	read = 3,
	noToken = 5,
	failed = 9
}
